import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { type ReactNode, useMemo } from "react";

import { HoldToConfirmButton } from "./HoldToConfirmButton";

interface DestructiveHoldToConfirmButtonProps {
  children: ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  onConfirm: () => void;
}

export function DestructiveHoldToConfirmButton(
  props: DestructiveHoldToConfirmButtonProps
): JSX.Element {
  const { children, isLoading = false, disabled = false, onConfirm } = props;

  const baseTheme = useTheme();
  const destructiveHoldButtonTheme = useMemo(
    () =>
      createTheme(baseTheme, {
        palette: {
          components: {
            holdToConfirmButton: {
              default: baseTheme.palette.background.tertiary,
              confirmed: baseTheme.palette.intent?.error?.background,
            },
          },
        },
      }),
    [baseTheme]
  );

  return (
    <ThemeProvider theme={destructiveHoldButtonTheme}>
      <HoldToConfirmButton
        fullWidth
        size="large"
        disabled={disabled}
        isLoading={isLoading}
        sx={(theme) => ({
          color: theme.palette.error.light,
          border: `1px solid ${theme.palette.border?.primary}`,
        })}
        onConfirm={onConfirm}
      >
        {children}
      </HoldToConfirmButton>
    </ThemeProvider>
  );
}
